import React from "react";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";
import MagnetCursor from "../components/MagnetCursor";
import ScrollToTop from "../components/ScrollToTop";

function Faq({ faqs = [] }) {

  const displayFaqs = faqs;

  const handleAccordionClick = (e, index) => {
    e.preventDefault();
    const btn = e.currentTarget;
    const target = document.getElementById(`faqQuestion${index}`);
    if (!target) return;

    const isOpen = target.classList.contains("show");
    const parent = document.getElementById("faqAccordion");

    if (!isOpen && parent) {
      parent.querySelectorAll(".accordion-collapse.show").forEach((el) => {
        if (el === target) return;
        el.style.height = el.scrollHeight + "px";
        requestAnimationFrame(() => (el.style.height = "0px"));
        setTimeout(() => {
          el.classList.remove("show");
          el.style.height = "";
        }, 350);
        const headerBtn = el.parentElement?.querySelector(".accordion-button");
        if (headerBtn) {
          headerBtn.classList.add("collapsed");
          headerBtn.setAttribute("aria-expanded", "false");
        }
      });
    }

    if (isOpen) {
      target.style.height = target.scrollHeight + "px";
      requestAnimationFrame(() => (target.style.height = "0px"));
      setTimeout(() => {
        target.classList.remove("show");
        target.style.height = "";
      }, 350);
      btn.classList.add("collapsed");
      btn.setAttribute("aria-expanded", "false");
    } else {
      target.classList.add("show");
      target.style.height = "0px";
      requestAnimationFrame(() => (target.style.height = target.scrollHeight + "px"));
      setTimeout(() => {
        target.style.height = "";
      }, 350);
      btn.classList.remove("collapsed");
      btn.setAttribute("aria-expanded", "true");
    }
  };

  return (
    <div>
      <div className="faq-page-section bg-white">
        <div className="divider"></div>
        
        <div className="container text-center mb-5">
          <h2 className="faq-title">Հաճախ տրվող հարցեր</h2>
        </div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="faq-accordion service-details-faq">
                <div className="accordion" id="faqAccordion">
                  {displayFaqs.map((faq, index) => (
                    <div key={index} className="accordion-item">
                      <div className="accordion-header">
                        <button
                          className={`accordion-button ${index === 0 ? '' : 'collapsed'}`}
                          type="button"
                          onClick={(e) => handleAccordionClick(e, index)}
                          aria-expanded={index === 0 ? "true" : "false"}
                          aria-controls={`faqQuestion${index}`}
                        >
                          {faq.question}
                        </button>
                      </div>

                      <div
                        id={`faqQuestion${index}`}
                        className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                        style={{
                          transition: "height 0.35s ease",
                          overflow: "hidden",
                        }}
                      >
                        <div className="accordion-body">
                          {faq.answer}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-10 col-lg-8 col-xl-6">
              <div className="section-heading text-center">
                <h2 className="mb-4">Դեռ հարցեր ունե՞ք</h2>
                <p className="mb-5">
                  Մենք պատրաստ ենք պատասխանել ձեր բոլոր հարցերին։ 
                  Կապ հաստատեք մեզ հետ, և մեր փորձագետները կօգնեն ձեզ։
                </p>
                <Link to="/contact" className="btn btn-primary">
                  <span>
                    Կապ մեզ հետ <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                     Կապ մեզ հետ <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>

      <ScrollToTop />
    </div>
  );
}

export default Faq;